__turbopack_context__.v({
  "actionSlot": "BoardIllustration-module__QCv2NW__actionSlot",
  "caption": "BoardIllustration-module__QCv2NW__caption",
  "compact": "BoardIllustration-module__QCv2NW__compact",
  "descriptionRule": "BoardIllustration-module__QCv2NW__descriptionRule",
  "illustration": "BoardIllustration-module__QCv2NW__illustration",
  "lead": "BoardIllustration-module__QCv2NW__lead",
  "lines": "BoardIllustration-module__QCv2NW__lines",
  "nameRule": "BoardIllustration-module__QCv2NW__nameRule",
  "originalRule": "BoardIllustration-module__QCv2NW__originalRule",
  "priceRule": "BoardIllustration-module__QCv2NW__priceRule",
  "prices": "BoardIllustration-module__QCv2NW__prices",
  "rank": "BoardIllustration-module__QCv2NW__rank",
  "row": "BoardIllustration-module__QCv2NW__row",
  "rows": "BoardIllustration-module__QCv2NW__rows",
  "stepped": "BoardIllustration-module__QCv2NW__stepped",
});
